import { useEffect } from 'react';
import { Outlet, useMatch } from 'react-router';
import DesktopRightSection from '@/components/desktop-right-section';
import { useResizableWidth } from '@/hooks/use-resizable-width';
import { useIsDesktop, useShouldRetractRightSection } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import ContactIndexRoute from '@/routes/contact';
import MessagesIndexRoute from '@/routes/messages';
import GlobalSearchLayout from '@/routes/search/_layout';
import { setPanel, useLayoutStore } from '@/stores/layout-status';
import { useMessageStore } from '@/stores/message';
import cn from '@/utils/merge-class-names';

export function PanelLayout() {
  const isDesktop = useIsDesktop();
  const { key } = useMessageStore();
  const shouldRetractRightSection = useShouldRetractRightSection();

  const isMatchContactRoute = useMatch({
    path: ROUTES.CONTACT.$path(),
    end: true,
  });

  const isMatchSearchIndestRoute = useMatch({
    path: ROUTES.SEARCH.$path(),
    end: true,
  });

  const isMatchSearchBySessionRoute = useMatch({
    path: ROUTES.SEARCH.$path(),
    end: false,
  });

  useEffect(() => {
    if (isMatchContactRoute) setPanel('contact');
    if (isMatchSearchIndestRoute) setPanel('search');
    if (isMatchSearchBySessionRoute) setPanel('search-by-session');
  }, []);

  if (!isDesktop) return <Outlet />;

  return (
    <div className='flex flex-1'>
      <PanelSection />
      {(!shouldRetractRightSection || key !== 'default') && <DesktopRightSection />}
    </div>
  );
}

const PanelSection = () => {
  const { panel } = useLayoutStore();
  const matchSearchRoute = useMatch({
    path: ROUTES.SEARCH.$path(),
    end: false,
  });
  const shouldRetractRightSection = useShouldRetractRightSection();
  const messageKey = useMessageStore((s) => s.key);
  const { width, isDragging, handleMouseDown } = useResizableWidth();

  useEffect(() => {
    if (isDragging) {
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    } else {
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    }
    return () => {
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isDragging]);
  return (
    <>
      {(!shouldRetractRightSection || messageKey === 'default') && (
        <div
          className='size-full flex'
          style={{
            width: shouldRetractRightSection ? '100%' : `${width}%`,
          }}>
          {panel === 'contact' && <ContactIndexRoute />}
          {panel === 'message' && <MessagesIndexRoute />}
          {(panel === 'search' || panel === 'search-by-session') && <GlobalSearchLayout />}
          <div
            onMouseDown={handleMouseDown}
            className={cn('desktop:border-r desktop:border-neutral-300 desktop:w-1 transition-all duration-200', {
              'bg-primary': isDragging,
              'hover:bg-primary hover:border-primary hover:cursor-col-resize active:bg-primary active:border-primary':
                !isDragging,
            })}
          />
        </div>
      )}
      {/* 聊天室選單 */}
      {(!(panel === 'search' || panel === 'search-by-session') || !matchSearchRoute) && <Outlet />}
    </>
  );
};
